export const Podcasts = [
    {
        type: "Podcasts",
        name: "Best Animal Rights Podcasts We Could Find",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/podcasts/Vegan",
    },
    {
        type: "Podcasts",
        name: "Best Animal Rights Podcasts We Could Find",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/podcasts/Animal-Rights",
    },
    {
        type: "Podcasts",
        name: "Viral Vegan",
        category: "",
        author: "",
        description: "active",
        link: "https://vegancreativecompass.com/podcast",
    },
    {
        type: "Podcasts",
        name: "The Animal Advocate",
        category: "",
        author: "",
        description: "active",
        link: "https://open.spotify.com/show/0Ikyb2lptHU5RU8sAcpAiI",
    },
    {
        type: "Podcasts",
        name: "Vegan Vanguard",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-vegan-vanguard",
    },
    {
        type: "Podcasts",
        name: "Sentience Institute Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-sentience-institute-podcast",
    },
    {
        type: "Podcasts",
        name: "The Disclosure Podcasts (eathling Ed)",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-disclosure-podcast",
    },
    {
        type: "Podcasts",
        name: "Our Hen House",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/series-2399272",
    },
    {
        type: "Podcasts",
        name: "Knowing Animals",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/2394606",
    },
    {
        type: "Podcasts",
        name: "The Vegan Ari Show",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-veganari-show",
    },
    {
        type: "Podcasts",
        name: "The Vevolution Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-vevolution-podcast",
    },
    {
        type: "Podcasts",
        name: "The Carbstrong Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-carbstrong-cast",
    },
    {
        type: "Podcasts",
        name: "Voices For The Animals",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/voices-for-the-animals",
    },
    {
        type: "Podcasts",
        name: "Beyond Species",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/beyond-species",
    },
    {
        type: "Podcasts",
        name: "The V Spot",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/series-2354614",
    },
    {
        type: "Podcasts",
        name: "The Livegan Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/series-2285983",
    },
    {
        type: "Podcasts",
        name: "Animal Matters",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/animal-matters",
    },
    {
        type: "Podcasts",
        name: "The Peta Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-peta-podcast",
    },
    {
        type: "Podcasts",
        name: "No Meat Athlete",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/no-meat-athlete-radio-79294",
    },
    {
        type: "Podcasts",
        name: "The Vegan Revolution Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/theveganrevolution",
    },
    {
        type: "Podcasts",
        name: "The Two Vegans",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-two-vegans",
    },
    {
        type: "Podcasts",
        name: "Animalogy",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/animalogy-the-animals-in-our-everyday-words-phrases",
    },
    {
        type: "Podcasts",
        name: "Animal Law Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/animal-law",
    },
    {
        type: "Podcasts",
        name: "Wildness Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/wildness",
    },
    {
        type: "Podcasts",
        name: "The Minimalist Vegan",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-minimalist-vegan-podcast",
    },
    {
        type: "Podcasts",
        name: "The Chickpeeps",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-chickpeeps-vegan-podcast",
    },
    {
        type: "Podcasts",
        name: "Vegan Business Talk",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/vegan-business-talk",
    },
    {
        type: "Podcasts",
        name: "The Viva! Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/viva-vegan-podcast",
    },
    {
        type: "Podcasts",
        name: "Awesome Vegans",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/awesome-vegans-with-elysabeth-alfano",
    },
    {
        type: "Podcasts",
        name: "Nz Vegan Podcast",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/nz-vegan-podcast",
    },
    {
        type: "Podcasts",
        name: "Vegan News",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/vegan-news",
    },
    {
        type: "Podcasts",
        name: "The Bearded Vegans",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/the-bearded-vegans",
    },
    {
        type: "Podcasts",
        name: "Brown Vegan",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/brown-vegan-2394840",
    },
    {
        type: "Podcasts",
        name: "Talking Animals",
        category: "",
        author: "",
        description: "inactive (since April 1, 2019)",
        link: "https://player.fm/series/talking-animals-1000485",
    },
    {
        type: "Podcasts",
        name: "The Vegan Podcast",
        category: "",
        author: "",
        description: "inactive (since February 4, 2020)",
        link: "https://player.fm/series/the-vegan-podcast",
    },
    {
        type: "Podcasts",
        name: "Arzone Podcast",
        category: "",
        author: "",
        description: "inactive (since August 16th, 2017)",
        link: "https://player.fm/series/arzone-animal-rights-zone-podcasts",
    },
    {
        type: "Podcasts",
        name: "Vegan Warrior Princess Attack!",
        category: "",
        author: "",
        description: "inactive (since November 21, 2019)",
        link: "https://player.fm/series/vegan-warrior-princesses-attack",
    },
    {
        type: "Podcasts",
        name: "The Species Barrier",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/2532012",
    },
    {
        type: "Podcasts",
        name: "Including Animals",
        category: "",
        author: "",
        description: "active",
        link: "https://player.fm/series/including-animals",
    },
    {
        type: "Podcasts",
        name: "Food For Thought - by Colleen Patrick-Goudreau",
        category: "",
        author: "",
        description: "active",
        link: "https://open.spotify.com/show/6D2plKD7Qh2mn4ps5KuPQ3?si=pZv3zfVaTxulVOk7XV2HWg",
    },
    {
        type: "Podcasts",
        name: "Vegan Abattoir",
        category: "",
        author: "",
        description: "",
        link: "https://open.spotify.com/show/7cwDXiNzFpPhGpocS267oB?si=aWuhjJRtTrSHCwu7nnyWNw",
    },
    {
        type: "Podcasts",
        name: "TryVeg Podcast",
        category: "",
        author: "",
        description: "",
        link: "https://podcasts.apple.com/us/podcast/vegan-family-podcast/id1446886019",
    },
];
